import { selectCountries } from "../../../components/appData.slice";
import { FormElement } from "../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../components/types";
import { Url } from "../../../router/enums";
import { provinces } from "../../../shared";
import { selectIsDefaultCountrySelected } from "../../../store/HOC/genericUI.selectors";

import { ComponentId, SectionId } from "./enums";
import { selectFormData, selectUIData } from "./vehicle.selectors";
import { setUIField, setIsDriveable } from "./vehicle.slice";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  redirect: Url.AC_APPLICANT,
  selector: selectFormData,
  content: [
    {
      title: "Dane pojazdu Zgłaszającego",
      sections: [
        {
          id: "reporter-vehicle-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.VEHICLE_REGISTRATION_NUMBER,
              label: "Numer rejestracyjny pojazdu",
              required: true,
            },
            {
              type: FormElement.NUMBER,
              suffix: "km",
              id: ComponentId.VEHICLE_MILEAGE,
              label: "Przebieg pojazdu w momencie zdarzenia",
              placeholder: "np. 120000",
            },
          ],
        },
        {
          id: "reporter-vehicle-data-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.VEHICLE_CITY,
              label: "Miasto użytkowania pojazdu",
              required: true,
            },
          ],
        },
        //JIRA LPPLWEBMOB-750
        {
          id: SectionId.AC_VEHICLE_DRIVEABLE,
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.VEHICLE_DRIVEABLE,
              label: "Czy pojazd został odholowany?",
              required: true,
              onChange: setIsDriveable,
              items: [
                {
                  label: "tak",
                  value: "false",
                },
                {
                  label: "nie",
                  value: "true",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: "Preferowane miejsce naprawy pojazdu",
      sections: [
        {
          id: "preferred-repair-place-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.AUTOCOMPLETE,
              id: ComponentId.COUNTRY_REPAIR,
              onChange: setUIField,
              items: selectCountries,
              label: "Kraj",
              required: true,
            },
            {
              type: FormElement.SELECT,
              id: ComponentId.PROVINCE_REPAIR,
              disabled: selectIsDefaultCountrySelected(selectUIData)(
                ComponentId.COUNTRY_REPAIR
              ),
              label: "Województwo",
              required: true,
              items: [...provinces],
            },
          ],
        },
        {
          id: "preferred-repair-place-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.CITY_REPAIR,
              label: "Miejscowość",
              required: true,
            },
          ],
        },
      ],
    },
  ],
};
